import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FETCH_DESTINATIONS_REQUESTED } from './../../destination/list/list.action';
import { FETCH_LOCATIONS_REQUESTED, FETCH_LOCATION_BY_DESTINATION_ID_REQUESTED, FETCH_LOCATIONS_SUCCEEDED } from './../../location/list/list.action';
import { Inventory } from './../invetory.reducer';
import { NotificationService } from './../../../common/services/notification/notification.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { Exception } from '../../../common/exceptions/exception';
import store from '../../../store/store.module';
import {
	FETCH_INVENTORY_REQUESTED,
	FETCH_INVENTORY_SUCCEEDED,
	UPDATE_INVENTORY_DESTINATION,
	BULK_UPDATE_INVENTORIES_LOCATION_REQUESTED,
	SELECT_INVENTORY,
	SELECT_ALL_ITEMS,
	FILTER_INVENTORY_REQUESTED,
	UPDATED_DESTINATION_LOCATIONS_REQUESTED,
	SEARCH_INVENTORY_REQUESTED,
	INVENTORY_UPDATE_PRODUCT_DESTINATION,
	INVENTORY_SAVE_PRODUCT_LOCATION,
	INVENTORY_UPDATE_PRODUCT_LOCATION,
	PRE_FILL_FILTER_FILTER,
	SELECT_DESTINATION_OF_PENDING_PRODUCT,
	SELECT_LOCATION_OF_PENDING_PRODUCT
} from './list.action';
import { UtilityService } from '../../../common/services/utility/utility.service';
import { Subscription } from 'rxjs/Subscription';
import { SAVE_PRODUCT_LOCATION, UPDATE_MULTI_PRODUCT_LOCATION_REQUESTED } from '../batch/batch.actions';
import { MultiSearchAction } from '../../../models/MultiSearchAction';
import {GET_ALL_PROCESS_STATUSES_REQUESTED} from "../../process-status/process-status.actions";

@Component({
	selector: 'app-list',
	templateUrl: './list.component.html',
	styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {
	navigationSubscription: Subscription;
	store = store;

	public INVENTORY_SAVE_PRODUCT_LOCATION = INVENTORY_SAVE_PRODUCT_LOCATION;
	public INVENTORY_UPDATE_PRODUCT_DESTINATION = INVENTORY_UPDATE_PRODUCT_DESTINATION;
	public INVENTORY_UPDATE_PRODUCT_LOCATION = INVENTORY_UPDATE_PRODUCT_LOCATION;
	public SELECT_DESTINATION_OF_PENDING_PRODUCT = SELECT_DESTINATION_OF_PENDING_PRODUCT;
	public SELECT_LOCATION_OF_PENDING_PRODUCT = SELECT_LOCATION_OF_PENDING_PRODUCT;
	public SAVE_PRODUCT_LOCATION = SAVE_PRODUCT_LOCATION;
  public isOpen = true;
	public search_actions = _.map(
		[
			{
				label: 'Product SKU',
				queryParamKey: 'skus',
				placeholder: 'Search by product SKU, ex SVSGBG34722,SVSGCL34749,SVSGCL83214'
			},
			{
				label: 'Keyword',
				placeholder: 'Search by product name'
			}
		],
		action => new MultiSearchAction(action)
	);

	protected filters = {};
  public processStatusIds = [];
	constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, private route: Router) {
    this.activeRouter = activeRouter;
    this.route = route;
    store.dispatch({ type: GET_ALL_PROCESS_STATUSES_REQUESTED });
		this.navigationSubscription = this.route.events.subscribe((e: any) => {
			if (e instanceof NavigationEnd) {
				store.dispatch({ type: FETCH_INVENTORY_REQUESTED, data: this.getQuery() });
        this.processStatusIds = [];
				if (!_.isUndefined(this.activeRouter.snapshot.queryParams.constraints)) {
					let constraints = JSON.parse(this.activeRouter.snapshot.queryParams.constraints);
					if (!_.isUndefined(constraints.destination_id)) {
						if (!_.isUndefined(constraints.location_id)) {
							store.dispatch({ type: PRE_FILL_FILTER_FILTER, data: { destination_id: constraints.destination_id, location_id: constraints.location_id } });
						} else {
							store.dispatch({ type: PRE_FILL_FILTER_FILTER, data: { destination_id: constraints.destination_id } });
						}
					} else {
						store.dispatch({ type: PRE_FILL_FILTER_FILTER, data: {} });
					}
          if (!_.isUndefined(constraints.process_status)) {
            if (!_.isUndefined(constraints.location_id)) {
              this.processStatusIds = constraints.process_status.split(',').map(s => parseInt(s));
              store.dispatch({ type: PRE_FILL_FILTER_FILTER, data: { process_status: this.processStatusIds } });
            }
          }
				} else {
					store.dispatch({ type: PRE_FILL_FILTER_FILTER, data: {} });
				}
        if (!_.isUndefined(this.activeRouter.snapshot.queryParams.open)) {
				  this.isOpen = this.activeRouter.snapshot.queryParams.open === 'true';
        }
			}
		});
	}

	ngOnInit() {}

	ngOnDestroy() {
		if (!_.isUndefined(this.navigationSubscription)) {
			this.navigationSubscription.unsubscribe();
		}
	}

	filterProcessStatus() {
    store.dispatch(
      {
        type: 'UPDATE_INVENTORY_FILTER',
        field: 'process_status',
        data: store.getState().ProcessStatus.all.items.filter(s => !!s.isChecked).map(s => s.id)
      }
    );
  }
  checkOpen() {
    // this.isOpen = !this.isOpen;
    let queryParams = this.activeRouter.snapshot.queryParams;
    const url = this.activeRouter.snapshot.url;
    if (_.isUndefined(queryParams.open)) {
      this.isOpen = true;
    } else {
      if (queryParams.open === 'true') {
        this.isOpen = false;
      } else {
        this.isOpen = true;
      }
    }
    queryParams = _.assign({}, this.activeRouter.snapshot.queryParams, { open: this.isOpen });
    this.route.navigate([url], { queryParams: queryParams });
  }

	public getQuery(): object {
		let supportedParams = ['sort', 'constraints', 'page', 'per_page', 'search', 'skus'];
		let queryParams = { page: 1 };
		if (_.keys(this.activeRouter.snapshot.queryParams).length > 0) {
			queryParams = _.assign(queryParams, this.activeRouter.snapshot.queryParams);
		}
		return _.pick(queryParams, supportedParams);
	}

	addMultiProductToInventory(products) {
		let missing_destination = false;
		_.forEach(products, item => {
			if (_.isNil(item.destination_id)) {
				missing_destination = true;
			}
		});
		if (missing_destination) {
			this.notification.show('warning', 'Please select destination', 3000);
			return false;
		}
		store.dispatch({
			type: UPDATE_MULTI_PRODUCT_LOCATION_REQUESTED,
			data: _.map(products, item => {
				return {
					product_sku: item.getSku(),
					destination_id: item.destination_id,
					location_id: item.location_id
				};
			}),
			com: 'INVENTORY_PRODUCT'
		});
	}
}
